import React, { useLayoutEffect, useRef, useState } from 'react';
import { RULE_PLACEHOLDERS } from '@/lib/tagRules';

// Text input that opens an inline placeholder picker when "{" is typed.
export function PlaceholderInput({ value, onChange, className, testid, ...rest }) {
  const ref = useRef(null);
  const [menu, setMenu] = useState(null); // { start, query }
  const [hi, setHi] = useState(0);
  const caret = useRef(null);
  useLayoutEffect(() => {
    if (caret.current == null || !ref.current) return;
    ref.current.setSelectionRange(caret.current, caret.current);
    caret.current = null;
  }, [value]);
  const opts = menu ? RULE_PLACEHOLDERS.filter((p) => p.id.startsWith(menu.query.toLowerCase())) : [];
  const sync = (el) => {
    const m = el.value.slice(0, el.selectionStart).match(/\{(\w*)$/);
    setMenu(m ? { start: el.selectionStart - m[0].length, query: m[1] } : null);
    setHi(0);
  };
  const pick = (p) => {
    const el = ref.current;
    const end = el.selectionStart;
    const next = `${value.slice(0, menu.start)}{${p.id}}${value.slice(end)}`;
    onChange(next);
    setMenu(null);
    caret.current = menu.start + p.id.length + 2;
  };
  const onKeyDown = (e) => {
    if (!opts.length) return;
    if (e.key === 'ArrowDown') { e.preventDefault(); setHi((h) => (h + 1) % opts.length); }
    else if (e.key === 'ArrowUp') { e.preventDefault(); setHi((h) => (h - 1 + opts.length) % opts.length); }
    else if (e.key === 'Enter' || e.key === 'Tab') { e.preventDefault(); pick(opts[hi]); }
    else if (e.key === 'Escape') setMenu(null);
  };
  return (
    <div className="relative">
      <input ref={ref} value={value} {...rest} className={`${className} w-full`} data-testid={testid}
        onChange={(e) => { onChange(e.target.value); sync(e.target); }} onKeyDown={onKeyDown}
        onClick={(e) => sync(e.target)} onBlur={() => setTimeout(() => setMenu(null), 150)} />
      {opts.length ? (
        <ul className="absolute left-0 top-full z-20 mt-1 max-h-56 w-72 overflow-y-auto rounded-lg border border-border bg-card py-1 shadow-lg" data-testid={`${testid}-placeholder-menu`}>
          {opts.map((p, i) => (
            <li key={p.id}>
              <button type="button" onMouseDown={(e) => { e.preventDefault(); pick(p); }} onMouseEnter={() => setHi(i)}
                className={`flex w-full items-baseline justify-between gap-3 px-3 py-1.5 text-left text-sm ${i === hi ? 'bg-secondary' : ''}`}
                data-testid={`${testid}-placeholder-${p.id}`}>
                <span className="font-mono text-foreground">{`{${p.id}}`}</span>
                <span className="truncate text-[length:calc(var(--fs,1)*0.6875rem)] text-muted-foreground">{p.desc}</span>
              </button>
            </li>
          ))}
        </ul>
      ) : null}
    </div>
  );
}
